export const onlyTextValidator = (value: unknown, optional: boolean = false): boolean => {
  if (typeof value !== 'string') {
    return false;
  }

  if (optional && value.trim().length === 0) {
    return true;
  }

  const regex = /^[a-zA-Zà-üÀ-Ü\s]+$/;

  return regex.test(value.trim());
};
